module.exports = __webpack_public_path__ + "img/IconFlightDeckLight.0ced5395.png";